<template>
  <div id="searchandsort" class="has-margin-bottom-20">
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div class="columns is-multiline">
      <form class="flex-row" action method="post" @submit.prevent="search">
        <div class="column is-4 align-self-flex-end">
          <b-field>
            <b-input type="search" icon="magnify" placeholder="Search..." v-model="searchQuery"></b-input>
            <p class="control">
              <button class="button is-primary is-search">Search</button>
            </p>
          </b-field>
        </div>
        <div class="column is-3">
            <date-picker placeholder="DATE: FROM" v-model="newStartDate" input-class="input" @selected="dateFormatingStartDate"></date-picker>
        </div>
        <div class="column is-3">
            <date-picker placeholder="DATE: TO" :disabledDates="disabledDates" v-model="newEndDate" input-class="input" @selected="dateFormatingEndDate"></date-picker>
        </div>
        <div class="column is-2 align-self-flex-end">
          <button class="button is-primary has-width-100-percent">Filter</button>
        </div>
      </form>
      <div v-if="clearSearch" class="column is-2 align-self-flex-end">
        <button class="button has-width-100-percent" @click="clearSearchField">Clear Search</button>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vuejs-datepicker";
import * as moment from "moment";

export default {
  name: "search",
  components: { DatePicker },
  props: {
    shipperSearchFunction: Function,
    clearSearch: Boolean,
    clearSearchFunction: Function,
    portSearchFunction: Function,
    nimasaSearchFunction: Function
  },
  data() {
    return {
      searchQuery: "",
      startDate: "",
      endDate: "",
      userRole: null,
      userID: null,
      isLoading: false,
      params: null,
      portID: null,
      newStartDate: null,
      newEndDate: null,
      currentPage: 1
    };
  },
  mounted() {
    this.userRole = this.getUserRole();
    this.userID = this.getUserID();
    this.portID = this.getUserPortID();
  },
  computed: {
    disabledDates: function (){
      if (this.startDate) {
        const disabledDate = new Date(
        this.newStartDate.getFullYear(),
        this.newStartDate.getMonth(),
        this.newStartDate.getDate()
      );
        return { to: disabledDate };
      } else {
        return
      }
    }
  },
  methods: {
    getUserRole() {
      return this.$store.getters.getUserRole;
    },
    getUserID() {
      return this.$store.getters.getUserID;
    },
    getUserPortID() {
      return this.$store.getters.getPortID;
    },
    clearSearchField() {
      this.searchQuery = "";
      this.newStartDate = "";
      this.newEndDate = "";
      this.startDate = "";
      this.endDate = "";
      this.clearSearchFunction();
    },
    dateFormatingStartDate(date) {
      let formattedDate = moment(date)
        .utc()
        .format("YYYY-MM-DD");
      if (formattedDate) {
        return (this.startDate = formattedDate);
      } else {
        return;
      }
    },
    dateFormatingEndDate(date) {
      let formattedDate = moment(date)
        .utc()
        .format("YYYY-MM-DD");
      if (formattedDate) {
        return (this.endDate = formattedDate);
      } else {
        return;
      }
    },
    search() {
      if (this.userRole === "SHIPPER_USER") {
        return this.shipperSearchFunction(
          this.currentPage,
          this.searchQuery.toLowerCase(),
          this.userID,
          this.startDate,
          this.endDate
        );
      } else if (this.userRole === "PORT_USER") {
        return this.portSearchFunction(
          this.currentPage,
          this.searchQuery.toLowerCase(),
          this.portID,
          this.startDate,
          this.endDate
        );
      } else if (this.userRole === "NIMASA_USER" || "NIMASA_MANAGER") {
        return this.nimasaSearchFunction(
          this.currentPage,
          this.searchQuery.toLowerCase(),
          this.startDate,
          this.endDate,
          this.userRole
        );
      }
    }
  }
};
</script>
